import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import type {AutocompletionDefinitions} from "widgets/constants";
import TImagePickerWidget from "../component";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import {Stylesheet} from "../../../entities/AppTheming";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TImagePicker extends TaroWidget<TImagePickerWidgetProps, WidgetState> {
  constructor(props: TImagePickerWidgetProps) {
    super(props);
    this.updateMetaValue = this.updateMetaValue.bind(this);
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string"
    };
  }

  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.value || this.defaultValue }}`,
      isValid: `{{ this.isRequired ? (!!this.value) : true }}`
    };
  }
  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
      fontSize: "{{appsmith.theme.form.label.fontSize}}",
      color: "{{appsmith.theme.form.label.fontColor}}",
      fontStyle: "{{appsmith.theme.form.label.fontStyle}}",
    };
  }
  updateMetaValue = (value: any) => {
    this.props.updateWidgetMetaProperty('value', value);
  }

  getPageView() {
    return (
      <TImagePickerWidget {...this.props} updateMetaValue={this.updateMetaValue} />
    );
  }
  static getWidgetType(): WidgetType {
    return "AT_IMAGE_PICKER_WIDGET";
  }
}

export interface TImagePickerWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TImagePicker;
